import { Dialog, Transition } from "@headlessui/react";
import { AiOutlineClose } from "react-icons/ai";
import React, { Fragment, useState } from "react";
import styles from "./EventAccessCode.module.css";
import { Spinner } from "@components/Spinner/Spinner";

const EventAccessCode = ({
  isOpen,
  onPasswordSubmit,
  onClose,
  passwordError,
}) => {
  const [password, setPassword] = useState("");

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = () => {
    onPasswordSubmit(password);
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className={styles.dialog} onClose={onClose}>
        <Dialog.Overlay className={styles.overlay} />
        <div className={styles.box}>
          <button
            className={styles.closeButton}
            onClick={() => {
              onClose();
              setIsLoading(true);
            }}
          >
            {!isLoading ? <AiOutlineClose size={30} /> : <Spinner />}
          </button>
          <Dialog.Title>Enter Access Code </Dialog.Title>
          <div className={styles.relative}>
            <input
              type="text"
              value={password}
              onChange={handlePasswordChange}
              style={{ color: "black", backgroundColor:"white !important" }}
            />
            <span className={styles.error}>
              {passwordError && passwordError}
            </span>
          </div>
          <button onClick={handleSubmit}>Submit</button>
        </div>
      </Dialog>
    </Transition>
  );
};

export default EventAccessCode;
